import { FID_SET} from '../shared/action-names';
import { fidActionTypes } from './types';

export function fidSet(fid: string): fidActionTypes {
  return { type: FID_SET, payload: fid };
}
